import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychooseretail() {
  return (
    <section className="voice_services why_choose_speech why_choose_retail p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose Us as Your <span>Retail App Development</span> Company?
            </h2>
            <p>
              We provide expert retail app development services focused on
              delivering results that transform your business. From optimized
              operations to enhanced customer satisfaction, our solutions are
              tailored to meet the evolving demands of the retail industry.
            </p>
            <p>
              Our fast development process gets your app to market quickly, and
              we offer continuous support to keep it secure and updated. Choose
              us for retail apps that grow your business, increase customer
              engagement, and drive efficiency from day one.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Omni-channel Integration</h5>
                    <p>
                      Connect online and offline channels for a seamless
                      shopping experience across all platforms.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Real-time Inventory <br /> Sync
                    </h5>
                    <p>
                      Track inventory in real time to reduce stock issues and
                      improve product availability.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Secure, Fast
                      <br /> Payments
                    </h5>
                    <p>
                      Integrate PCI-compliant payment gateways for smooth,
                      secure transactions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Personalized Customer Experience</h5>
                    <p>
                      Leverage AI for tailored product recommendations, boosting
                      customer retention.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Data-Driven
                      <br /> Decisions
                    </h5>
                    <p>
                      Use built-in analytics to track sales trends and customer
                      behavior for better decision-making.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Scalable Cloud <br /> Solutions
                    </h5>
                    <p>
                      Ensure your app grows with your business using a scalable
                      cloud infrastructure.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Optimized <br /> Performance
                    </h5>
                    <p>
                      Build fast, responsive apps that handle peak traffic
                      without disruptions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>
                      Order <br /> Management
                    </h5>
                    <p>
                      Simplify order processing with real-time updates on
                      shipping and delivery.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start Building Your Retail App
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseretail;
